import WatchlistRoutes from "./Routes";
import WatchlistsOverviewPage from "./pages/WatchlistsOverviewPage";
import WatchlistDetailsPage from "./pages/WatchlistDetailsPage";
const managementBindings = {
  routes: [
    {
      path: WatchlistRoutes.unqualified.LIST,
      component: WatchlistsOverviewPage,
      permissions: "watchlist:read"
    },
    {
      path: WatchlistRoutes.unqualified.DETAILS(":watchlistId"),
      component: WatchlistDetailsPage,
      permissions: "watchlist:read"
    }
  ]
};
export default managementBindings;
